export default  [
  {
    key: "owner",
    label: "Owner",
    sortable: true
  },

  {
    key: "contract",
    label: "Contract",
    sortable: true
  },

  {
    key: "device",
    label: "Device",
    sortable: true
  },

  {
    key: "plate",
    label: "Plate Number",
    sortable: true
  },


  {
    key: "date",
    label: "Date",
    sortable: true
  },

  {
    key: "area_name",
    label: "Geofence",
    sortable: true
  },

  {
    key: "start_sweep_time",
    label: "Start Sweep",
    sortable: true
  },

  {
    key: "end_sweep_time",
    label: "End Sweep",
    sortable: true
  },

  {
    key: "total_sweep_distance",
    label: "Sweep Distance",
    sortable: true
  },

  {
    key: "total_sweep_duration",
    label: "Sweep Time",
    sortable: true
  },

]